// extracted by mini-css-extract-plugin
export default {"profileNavLinks":"NavList_profileNavLinks__o2oAF","active":"NavList_active__wH9WD"};